export default __webpack_public_path__ + "static/media/roadrunnerKlein.86098e49.jpg";